import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import useNavScroll from '../hooks/useNavScroll';
import ServiceBar from '../sections/ServiceBar';
import styles from './Navbar.module.css';

const NAV_ITEMS = [
  { label: 'Home', href: '/' },
  {
    label: 'Church',
    children: [
      { label: "Pastor's Team", href: '/leadership' },
      { label: 'Branches', href: '/branches' },
      { label: 'Mission & Vision', href: '/missionandvision' },
      { label: 'Our Beliefs', href: '/beliefs' },
      { label: 'Church Bylaws', href: '/bylaws' },
    ],
  },
  {
    label: 'Ministries',
    children: [
      { label: 'LAMBS', href: '/lambs' },
      { label: 'LION CUBS', href: '/young-lion-cubs' },
      { label: 'DAUGHTERS OF ZION', href: '/women' },
      { label: 'SERVICE SCHEDULE', href: '/eventscalendar' },
    ],
  },
  {
    label: 'Media',
    children: [
      { label: 'Outreach', href: '/outreach' },
      { label: 'Mission Trips', href: '/missiontrips' },
    ],
  },
  { label: "Member's Area", href: '/members-area' },
  { label: 'Partner With Us', href: '/prayer-request', isCta: true },
];

export default function Navbar() {
  const scrolled = useNavScroll(60);
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleLogoClick = () => {
    closeMobile();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const toggleMobile = () => {
    setMobileOpen(prev => {
      const next = !prev;
      document.body.style.overflow = next ? 'hidden' : '';
      return next;
    });
  };

  const closeMobile = () => {
    setMobileOpen(false);
    setOpenDropdown(null);
    document.body.style.overflow = '';
  };

  return (
    <header className={styles.header}>
      <ServiceBar />
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
        <NavLink
          to="/"
          className={styles.logo}
          aria-label="Faith Fellowship Church"
          onClick={handleLogoClick}
        >
          <img
            src="/assets/logos/logofull.webp"
            alt="Faith Fellowship Church"
            className={styles.logoImg}
            width="228"
            height="76"
            decoding="async"
          />
        </NavLink>

        <ul className={styles.menu}>
          {NAV_ITEMS.map(item => (
            <li key={item.label} className={styles.menuItem}>
              <NavLink
                to={item.href || '/'}
                end={item.href === '/'}
                className={({ isActive }) =>
                  `${styles.menuLink} ${item.isCta ? styles.giveBtn : ''} ${isActive && item.href ? styles.active : ''}`
                }
                onClick={e => {
                  if (!item.href) {
                    e.preventDefault();
                  } else if (item.href === '/' && location.pathname === '/') {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }}
              >
                {item.label}
                {item.children && <span className={styles.caret}>▾</span>}
              </NavLink>

              {item.children && (
                <div className={styles.dropdown}>
                  {item.children.map(child => (
                    <NavLink key={child.label} to={child.href} className={styles.dropLink}>
                      {child.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>

        <button
          className={`${styles.hamburger} ${mobileOpen ? styles.open : ''}`}
          onClick={toggleMobile}
          aria-label="Toggle menu"
          type="button"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`${styles.mobileDrawer} ${mobileOpen ? styles.mobileOpen : ''}`}>
        {NAV_ITEMS.map(item => (
          <div key={item.label}>
            {item.children ? (
              <button
                className={styles.mobileLink}
                onClick={() => setOpenDropdown(openDropdown === item.label ? null : item.label)}
                type="button"
              >
                {item.label}
                <span
                  className={`${styles.mobileCaret} ${openDropdown === item.label ? styles.mobileCaretOpen : ''}`}
                >
                  ▾
                </span>
              </button>
            ) : (
              <NavLink
                to={item.href || '/'}
                className={styles.mobileTopLink}
                onClick={() => {
                  closeMobile();
                  if (item.href === '/' && location.pathname === '/') {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }}
              >
                {item.label}
              </NavLink>
            )}

            {item.children && openDropdown === item.label && (
              <div className={styles.mobileSubMenu}>
                {item.children.map(child => (
                  <NavLink key={child.label} to={child.href} className={styles.mobileSubLink} onClick={closeMobile}>
                    {child.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </header>
  );
}
